import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    drawer: false,
    message: {
      type: null,
      text: null
    }
  },
  mutations: {
    setDrawer(state, payload) {
      state.drawer = payload;
    },
    setMessage(state, message) {
      state.message.type = message.type;
      state.message.text = message.text;
    },
    clearMessage(state) {
      state.message.type = null;
      state.message.text = null;
    }
  },
  actions: {
    setMessage({ commit }, payload) {
      commit("setMessage", payload);
    },
    clearMessage({ commit }) {
      commit("clearMessage");
    }
  },
  getters: {
    message: state => {
      return state.message;
    }
  },
  modules: {}
});
